export enum ControlTypeEnum {
  CheckBox = 'CheckBox',
  Slider = 'Slider'
}
